import listSaga from './listSaga'
import editSessionSaga from './editSessionSaga'
import oneSessionSaga from './oneSessionSaga'
import deleteSessionSaga from './deleteSessionSaga'
import createSessionSaga from './createSessionSaga'

const sessionsSagas = [listSaga(), oneSessionSaga(), editSessionSaga(), deleteSessionSaga(), createSessionSaga()]

export default sessionsSagas
